import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { logDeprecationMessage } from '../../../utils/logDeprecationMessage';
import styles from './svg-icon.module.scss';
export var svgIcon = function (svg, displayName) {
    if (displayName === void 0) { displayName = 'SvgIcon'; }
    logDeprecationMessage('Please use `import { IconName } from "@johnlewispartnership/wtr-ingredients/foundations/icons"');
    var Icon = function (_a) {
        var className = _a.className, isAnimated = _a.isAnimated;
        var icon = React.createElement("i", { className: classnames(styles.icon, displayName, className) }, svg);
        if (!isAnimated)
            return icon;
        return (React.createElement(TransitionGroup, null,
            React.createElement(CSSTransition, { classNames: {
                    enter: styles.enter,
                    enterActive: styles.enterActive,
                    exit: styles.exit,
                    exitActive: styles.exitActive,
                    exitDone: styles.exitDone,
                }, key: displayName, timeout: { enter: 100, exit: 0 } }, icon)));
    };
    Icon.propTypes = {
        // ----------------------------- Warning --------------------------------
        // | These PropTypes are generated from the TypeScript type definitions |
        // |     To update them edit the d.ts file and run "yarn proptypes"     |
        // ----------------------------------------------------------------------
        className: PropTypes.string,
        isAnimated: PropTypes.bool,
    };
    Icon.defaultProps = {
        className: undefined,
        isAnimated: false,
    };
    Icon.displayName = displayName;
    return Icon;
};
//# sourceMappingURL=svg-icon.js.map